<nwm-menu />
<div class="content">
  <div class="main row no-gutters mb-5 mt-4">
    <div class="col-xxl-10 offset-xxl-1 pb-4">
      <nwm-profile-myinfo />
    </div>
  </div>
</div>